module.exports = __webpack_public_path__ + "static/media/Santosh Ji Elevation.2d33e19f.jpg";